import { Asset } from './asset';
import { LiquidityBotRequest } from './liquidity-bot-request';

export class LiquidityBotRequestConditional extends LiquidityBotRequest {
  public expectedExecutionTimestamp: Date;

  public triggerAsset: Asset;
  public triggerCondition: 'above' | 'below';
  public triggerPrice: number;
}
